import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqKeys = [
  { q: 'home.faq1Q', a: 'home.faq1A' },
  { q: 'home.faq2Q', a: 'home.faq2A' },
  { q: 'home.faq3Q', a: 'home.faq3A' },
  { q: 'home.faq4Q', a: 'home.faq4A' },
  { q: 'home.faq5Q', a: 'home.faq5A' },
  { q: 'home.faq6Q', a: 'home.faq6A' },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/60 scroll-mt-20">
      <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t('home.faqTitle')}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            {t('home.faqSubtitle')}
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqKeys.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-base font-semibold text-foreground-900">
                    {t(faq.q)}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-500">
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{t(faq.a)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}